import {
  displayError,
  displayInfo,
  displayWarning,
} from "../../utils/messageToast";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";

export const getPathField = async (
  targetField: string,
  clientId: string,
  ambient: string,
  formId: string,
  authorization: string,
  groupField: string,
  form: any,
  signOut: () => void
) => {
  try {
    let pathField;
    const apiClient = SetupFlow(authorization);

    if (targetField === "") {
      displayWarning("O campo alvo não pode ser vazio!");
      return;
    }

    if (targetField === "customerEmail") {
      pathField = "{{ticket.customer.email}}";
      navigator.clipboard.writeText(pathField);
      displayInfo(`${pathField}`, 1000);
      return pathField;
    } else if (targetField === "customerName") {
      pathField = "{{ticket.customer.name}}";
      navigator.clipboard.writeText(pathField);
      displayInfo(`${pathField}`, 1000);
      return pathField;
    } else if (targetField === "customerPhoneNumber") {
      pathField = "{{ticket.customer.phone}}";
      navigator.clipboard.writeText(pathField);
      displayInfo(`${pathField}`, 1000);
      return pathField;
    } else if (targetField === "customerSocialNumber") {
      pathField = "{{ticket.customer.document}}";
      navigator.clipboard.writeText(pathField);
      displayInfo(`${pathField}`, 1000);
      return pathField;
    } else if (targetField === "cpf") {
      pathField = "{{ticket.customer.document}}";
      navigator.clipboard.writeText(pathField);
      displayInfo(`${pathField}`, 1000);
      return pathField;
    } else if (formId) {
      const getPayload = await apiClient.post(
        `/create-payload?alias=${formId}&clientId=${clientId}&ambient=${ambient}`,
        undefined
      );
      const getPath = await apiClient.post(
        `/take-the-path-field?targetField=${targetField}&targetGroupField=${groupField}`,
        getPayload.data.payload
      );
      navigator.clipboard.writeText(
        JSON.stringify(`{{${getPath.data.pathField}}}`, null, 2).replace(
          /"/g,
          ""
        )
      );
      displayInfo(`{{${getPath.data.pathField}}}`, 1000);
      return `{{${getPath.data.pathField}}}`;
    } else {
      const getPayload = await apiClient.post(
        `/create-payload?alias=${formId}&clientId=${clientId}&ambient=${ambient}`,
        form
      );
      const getPath = await apiClient.post(
        `/take-the-path-field?targetField=${targetField}&targetGroupField=${groupField}`,
        getPayload.data.payload
      );
      navigator.clipboard.writeText(
        JSON.stringify(`{{${getPath.data.pathField}}}`, null, 2).replace(
          /"/g,
          ""
        )
      );
      displayInfo(`{{${getPath.data.pathField}}}`, 1000);
      return `{{${getPath.data.pathField}}}`;
    }
  } catch (error: any) {
    displayError("Erro ao gerar caminho!");
    return;
  }
};
